type ButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  children?: React.ReactNode;
  buttonStyle?: "flat" | "outline";
  intent?: "primary" | "success" | "danger";
  background?: "default" | "card";
  disabled?: boolean;
};

const Button = (props: ButtonProps) => (
  <button
    disabled={props.disabled}
    className={`roka-btn ${props.buttonStyle || "flat"} ${props.intent || "primary"} ${props.background || "default"} ${props.className}`}
    onClick={props.onClick}
  >
    {props.children}
  </button>
);

export default Button;
